import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import 'flatpickr/dist/flatpickr.css';
import CONFIG from "@/assets/js/config.custom.js";
import EnrollmentInvoiceCreate from '@/controllers/custom/payment/enrollment-invoice-create.js';

export default {
    ...EnrollmentInvoiceCreate,
    name: 'enrollmentInvoiceEdit',
    data() {
        return {
            CONFIG,
            ...EnrollmentInvoiceCreate.data(),
            firstPaymentId: null,
        };
    },

    methods: {
        ...EnrollmentInvoiceCreate.methods,

        sanitizePaymentItemQuantity(paymentItem) {
            paymentItem.quantity = this.sanitizePositiveInteger(paymentItem.quantity);
            this.calculateGrossTotal();
        },

        /**
         * Get first tuition fee
         * @param {int} tuitionPaymentId 
         */
        getFirstTuitionFee(tuitionPaymentId) {
            axios.get(`enrollment/first-tuition-fee/${tuitionPaymentId}`)
                .then(response => {
                    this.tuitionFeeAmount = response.data.first_tuition_fee?.net_total_amt || 0;
                    this.firstPaymentDueDate = response.data.first_tuition_fee?.due_date || null;
                    this.firstPaymentId = response.data.first_tuition_fee?.id || null;
                    this.getExistingPaymentItemsForFirstPayment();
                    this.getExistingDiscountsForFirstPayment();
                })
                .catch(error => {
                    console.error("Error fetching tuition fee:", error);
                });
        },

        /**
         * Get existing payment items for first payment
         */
        getExistingPaymentItemsForFirstPayment() {
            axios.get(`enrollment/first-payment/items/${this.$route.params.tuitionPaymentId}`)
                .then(response => {
                    this.enrollmentPaymentItems = response.data || [];
                    this.calculateGrossTotal();
                })
                .catch(error => {
                    console.error("Error fetching payment items:", error);
                });
        },

        /**
         * Get existing discounts for first payment
         */
        getExistingDiscountsForFirstPayment() {
            axios.get(`enrollment/first-payment/discounts/${this.firstPaymentId}`)
                .then(response => {
                    this.discountItems = response.data || [];
                    this.calculateTotal();
                })
                .catch(error => {
                    console.error("Error fetching discounts:", error);
                });
        },

        /**
         * Overwrite parent method.
         * Get default payment items
         */
        getDefaultPaymentItems() { },

        /**
         * Save draft
         */
        updateDraft() {
            this.clearValidationErrors();
            this.disabled = true;
            axios.post(`enrollment/payment/update-draft/${this.$route.params.classStudentId}/${this.$route.params.tuitionPaymentId}`, {
                payment_items: this.enrollmentPaymentItems,
                discount_items: this.discountItems,
                payment_histories: this.paymentHistories,
                note: this.note,
            })
            .then(response => {
                this.disabled = false;
                if (response.data.success == true) {
                    this.$notification.success("Enrollment payment is successfully updated as draft", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                   this.showStatementDetail();
                }
            })
            .catch(error => {
                this.disabled = false;
                this.printValidationError(error.response);
                const errors = error.response?.data?.errors || {};
                if (errors.invalid_tuition_payment_id) {
                  this.$notification.error(errors.invalid_tuition_payment_id[0], {
                    timer: 3,
                    position: "bottomCenter",
                  });
                }
                console.error("Error fetching payment plan:", error);
                this.isLoading = false;
            });
        },

        /**
         * Redirect to student statement detail form
         */
        showStatementDetail() {
            this.$router.push({
                name: "studentStatementDetail",
                params: {
                    tuitionPaymentId: this.$route.params.tuitionPaymentId,
                }
            });
        },

        /**
         * Redirect to enrollment payment create form
         */
        showEnrollmentEditForm() {
          this.$router.push({
                name: "enrollmentPaymentEdit",
                params: {
                    tuitionPaymentId: this.$route.params.tuitionPaymentId,
                    classStudentId: this.$route.params.classStudentId,
                },
            });
        },

        /**
         * Make payment
         */
        makePayment() {
            if (!Array.isArray(this.paymentHistories) || this.paymentHistories.length === 0) {
                this.$notification.error("Make Payment requires at least one payment history", {
                    timer: 3,
                    position: "bottomCenter"
                });
                return;
            }

            // Require screenshot for approved histories
            for (let i = 0; i < this.paymentHistories.length; i++) {
                const history = this.paymentHistories[i];
                if (parseInt(history.status) === CONFIG.PAYMENT_STATUS.STATUS_APPROVED) {
                    if (!history.ss_image || history.ss_image.trim() === '') {
                        this.setValidationError('payment_histories.' + i + '.ss_image', 'Payment Screenshot is required.');
                        return;
                    }
                }
            }

            // Force payment_method_id to null for non-approved statuses
            const sanitizedHistories = this.paymentHistories.map(history => {
                if (history.status !== CONFIG.PAYMENT_STATUS.STATUS_APPROVED) {
                    return { ...history, payment_method_id: null };
                }
                return history;
            });

            this.disabled = true;
            axios.post(`enrollment/payment/make-payment-from-update/${this.$route.params.classStudentId}/${this.$route.params.tuitionPaymentId}`, {
                payment_items: this.enrollmentPaymentItems,
                discount_items: this.discountItems,
                payment_histories: sanitizedHistories,
                note: this.note,
            })
            .then(response => {
                this.disabled = false;
                this.disabled = false;
                if (response.data.success == true) {
                    this.$notification.success("Enrollment payment is successfully created", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                   this.showStatementDetail();
                }
            })
            .catch(error => {
                this.disabled = false;
                this.printValidationError(error.response);
                const errors = error.response?.data?.errors || {};
                const errorMsg = errors.invalid_tuition_payment_id?.[0];
                if (errorMsg) {
                    this.$notification.error(errorMsg, {
                        timer: 3,
                        position: "bottomCenter",
                    });
                }
                console.error("Error fetching payment plan:", error);
                this.isLoading = false;
            });
        }
    },

};
